export class ProductItemPersonalization {
  previewOrColorLogo: boolean;
  blackAndWhiteLogo: boolean;
  personalizedMessage: boolean;
}
